import { render, staticRenderFns } from "./ViewRules.vue?vue&type=template&id=13097aec"
import script from "./ViewRules.vue?vue&type=script&lang=js"
export * from "./ViewRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports